import React, { useState, useEffect } from 'react';
import './Flux2Home.css';
import ImageGenerator from './ImageGenerator';
import ImageGallery from './ImageGallery';
import ServerStatus from './ServerStatus';
import AccessCodeModal from './AccessCodeModal';
import { fluxAPI, accessCodeManager } from './api';

function Flux2Home() {
    const [serverStatus, setServerStatus] = useState(null);
    const [generatedImages, setGeneratedImages] = useState([]);
    const [showAccessCodeModal, setShowAccessCodeModal] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    // 초기 인증 확인
    useEffect(() => {
        const checkAuth = async () => {
            const code = accessCodeManager.getAccessCode();
            if (code) {
                const isValid = await accessCodeManager.validateAccessCode(code);
                setIsAuthenticated(isValid);
                if (!isValid) {
                    setShowAccessCodeModal(true);
                } else {
                    checkServerStatus();
                }
            } else {
                setShowAccessCodeModal(true);
            }
        };

        checkAuth();
    }, []);

    // 서버 상태 확인
    useEffect(() => {
        if (isAuthenticated) {
            checkServerStatus();
            const interval = setInterval(checkServerStatus, 30000); // 30초마다 확인
            return () => clearInterval(interval);
        }
    }, [isAuthenticated]);

    const checkServerStatus = async () => {
        try {
            const data = await fluxAPI.checkHealth();
            setServerStatus(data);
        } catch (error) {
            console.error('서버 상태 확인 실패:', error);
            if (error.response?.status === 401) {
                setIsAuthenticated(false);
                setShowAccessCodeModal(true);
            }
            setServerStatus({ status: 'offline', error: error.message });
        }
    };

    const handleAccessCodeSubmit = async (code) => {
        const isValid = await accessCodeManager.validateAccessCode(code);
        if (isValid) {
            setIsAuthenticated(true);
            setShowAccessCodeModal(false);
            checkServerStatus();
        }
        return isValid;
    };

    const handleChangeAccessCode = () => {
        setShowAccessCodeModal(true);
    };

    const handleImageGenerated = (imageInfo) => {
        setGeneratedImages(prev => [imageInfo, ...prev]);
    };

    return (
        <div className="flux2-home">
            <AccessCodeModal
                isOpen={showAccessCodeModal}
                onSubmit={handleAccessCodeSubmit}
                onClose={isAuthenticated ? () => setShowAccessCodeModal(false) : null}
            />

            <header className="flux2-header">
                <h1>🎨 FLUX.2-dev 이미지 생성기</h1>
                <div className="header-right">
                    <ServerStatus status={serverStatus} />
                    {isAuthenticated && (
                        <button
                            className="change-code-btn"
                            onClick={handleChangeAccessCode}
                            title="Access Code 변경"
                        >
                            🔑
                        </button>
                    )}
                </div>
            </header>

            <main className="flux2-main">
                {isAuthenticated ? (
                    <>
                        <ImageGenerator
                            onImageGenerated={handleImageGenerated}
                            serverReady={serverStatus?.pipeline_loaded}
                        />

                        <ImageGallery images={generatedImages} />
                    </>
                ) : (
                    <div className="auth-required">
                        <p>서비스를 사용하려면 Access Code가 필요합니다.</p>
                    </div>
                )}
            </main>

            <footer className="flux2-footer">
                <p>Powered by FLUX.2-dev | Black Forest Labs</p>
                <p className="proxy-info">🔒 인증 프록시를 통해 보호됨</p>
            </footer>
        </div>
    );
}

export default Flux2Home;